import { travelerFromFirestore } from '@parallel-fluidics/shared/models/travelers';
import { useQuery } from '@tanstack/react-query';
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from 'firebase/firestore';

/**
 * One-shot load of the finished-goods on-hand set for a product version:
 * every traveler currently attached to this inventory that has not shipped.
 * This mirrors the `currentTravelerQuery` used server-side by
 * `reconcileInventoryTravelersV2`, so the client diff matches what the
 * callable will do on commit.
 *
 * Unpaginated on purpose — a reconciliation session needs the whole expected
 * set in memory to diff scans against it.
 */
export default function useExpectedInventoryTravelers(productDocId, versionId) {
  return useQuery({
    queryKey: ['expectedInventoryTravelers', productDocId, versionId],
    enabled: Boolean(productDocId && versionId),
    staleTime: 0,
    queryFn: async () => {
      const travelersQuery = query(
        collection(getFirestore(), 'travelers'),
        where('productDocId', '==', productDocId),
        where('productVersionId', '==', versionId),
        where('shipped', '==', false),
      );
      const snap = await getDocs(travelersQuery);
      return snap.docs.map((docSnap) => travelerFromFirestore(docSnap));
    },
  });
}
